export default [
  {
    path: '/main/status',
    meta: {
      tag: 'list_status',
      name: 'Status',
      breadcrumb: 'Status'
    },
    component: () => import(/* webpackChunkName: "status-list" */ '@/views/main/settings/stock-registers/status/Index.vue'),
    children: [
      {
        path: '',
        name: 'liststatus',
        meta: {
          tag: 'list_status',
          menu: 'settings',
          name: 'Status',
        },
        component: () => import(/* webpackChunkName: "status-list" */ '@/views/main/settings/stock-registers/status/List.vue')
      },
      {
        path: '/main/status/add',
        name: 'addstatus',
        meta: {
          tag: 'add_status',
          menu: 'settings',
          name: 'Adicionar | Status',
          breadcrumb: 'Adicionar Status'
        },
        component: () => import(/* webpackChunkName: "status-add" */ '@/views/main/settings/stock-registers/status/Add.vue')
      },
      {
        path: '/main/status/:id',
        name: 'editstatus',
        meta: {
          tag: 'edit_status',
          menu: 'settings',
          name: 'Editar | Status',
          breadcrumb: 'Editar Status'
        },
        component: () => import(/* webpackChunkName: "status-edit" */ '@/views/main/settings/stock-registers/status/Edit.vue')
      }
    ]
  }
]